import { axios } from '@/lib/axios'
import CrudService from '@/services/crudService'

class FileService extends CrudService {
  constructor() {
    super('files')
  }

  uploadFile = async ({ version, type, files }) => {
    try {
      const form = new FormData()
      form.append('type', type)
      form.append('version', version)

      for (let i = 0; i < files.length; i++) {
        form.append('file', files[i])
      }

      const response = await axios.post(`/${this.resource}`, form)
      return response.data
    } catch (error) {
      console.error(`Error uploading file`, error)
      throw error
    }
  }

  downloadFile = async (id) => {
    const response = await axios.get(`${this.resource}/${id}/file`, {
      responseType: 'blob',
    })

    return response
  }

  getFileDetailOnSharepoint = async (offerId) => {
    if (offerId) {
      const response = await axios.get(`offers/sharepoint/getTenderDocumentLink/${offerId}`)
      return response.data.data
    }
  }
}

export default FileService
